(() => {
  'use strict';
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    const button = root.querySelector('.fl-submit');
    const error = root.querySelector('.fl-error');
    const status = root.querySelector('[data-status]');
    const guestWrap = root.querySelector('.fl-guest');
    const guest = form.elements.guest;
    let submitting = false;
    let language = 'en';
    let errorKey = '';
    const messages = {
      en: { submit: 'COUNT ME IN', sending: 'SENDING…', status: 'Sending your RSVP.', unavailable: 'RSVP is not available yet. Please try again later.', failed: 'We couldn’t confirm your RSVP. Please try again — your details are still here.' },
      is: { submit: 'ÉG MÆTI', sending: 'SENDI…', status: 'Verið er að senda svarið þitt.', unavailable: 'Ekki er hægt að svara boðinu eins og er. Vinsamlegast reyndu aftur síðar.', failed: 'Ekki tókst að staðfesta svarið þitt. Reyndu aftur — upplýsingarnar þínar eru enn hér.' }
    };
    function refreshMessages() {
      button.textContent = messages[language][submitting ? 'sending' : 'submit'];
      status.textContent = submitting ? messages[language].status : '';
      if (errorKey) error.textContent = messages[language][errorKey];
    }
    function setLanguage(next) {
      language = next === 'is' ? 'is' : 'en';
      root.lang = language;
      document.documentElement.lang = language;
      root.querySelectorAll('[data-en][data-is]').forEach((element) => {
        element.textContent = element.dataset[language];
      });
      root.querySelectorAll('[data-language]').forEach((element) => {
        element.setAttribute('aria-pressed', String(element.dataset.language === language));
      });
      refreshMessages();
      try { localStorage.setItem('first-love-language', language); } catch (_) { /* Optional preference storage. */ }
    }
    let savedLanguage;
    try { savedLanguage = localStorage.getItem('first-love-language'); } catch (_) { /* Storage may be unavailable. */ }
    setLanguage(savedLanguage || 'is');
    root.querySelector('.fl-language').hidden = false;
    root.querySelectorAll('[data-language]').forEach((element) => {
      element.addEventListener('click', () => setLanguage(element.dataset.language));
    });
    const visualViewport = window.visualViewport;
    function updateKeyboardMetrics() {
      const viewportHeight = visualViewport ? visualViewport.height : window.innerHeight;
      const viewportTop = visualViewport ? visualViewport.offsetTop : 0;
      const keyboardInset = Math.max(0, window.innerHeight - viewportHeight - viewportTop);
      root.style.setProperty('--fl-keyboard-inset', `${Math.round(keyboardInset)}px`);
    }
    function revealFocusedField(field) {
      updateKeyboardMetrics();
      field.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
    }
    form.addEventListener('focusin', (event) => {
      if (!event.target.matches('input:not([type="radio"]):not([type="checkbox"])')) return;
      if (!window.matchMedia('(max-width: 699px)').matches) return;
      root.classList.add('fl-keyboard-open');
      updateKeyboardMetrics();
      window.setTimeout(() => revealFocusedField(event.target), 300);
    });
    form.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (form.contains(document.activeElement) && document.activeElement.matches('input:not([type="radio"]):not([type="checkbox"])')) return;
        root.classList.remove('fl-keyboard-open');
        root.style.removeProperty('--fl-keyboard-inset');
      }, 50);
    });
    if (visualViewport) {
      visualViewport.addEventListener('resize', () => {
        if (!root.classList.contains('fl-keyboard-open')) return;
        updateKeyboardMetrics();
        const active = document.activeElement;
        if (form.contains(active) && active.matches('input:not([type="radio"]):not([type="checkbox"])')) {
          window.setTimeout(() => revealFocusedField(active), 50);
        }
      });
    }
    function updateSubmitState() {
      const bringingGuest = form.elements.plusOne.checked;
      guestWrap.hidden = !bringingGuest;
      guest.disabled = !bringingGuest;
      guest.required = bringingGuest;
      if (!bringingGuest) guest.value = '';
      const valid = Array.from(form.elements).every((field) => !field.willValidate || field.validity.valid)
        && form.elements.name.value.trim().length > 0
        && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.elements.email.value.trim())
        && (!bringingGuest || guest.value.trim().length > 0);
      button.disabled = submitting || !valid;
    }
    function submitToEndpoint(endpoint, fields) {
      const randomPart = typeof crypto !== 'undefined' && crypto.getRandomValues
        ? Array.from(crypto.getRandomValues(new Uint32Array(2)), (value) => value.toString(36)).join('')
        : Math.random().toString(36).slice(2);
      const requestId = `${Date.now().toString(36)}-${randomPart}`;
      const body = new URLSearchParams({ ...fields, requestId });
      return fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body,
        cache: 'no-store',
        credentials: 'omit',
        redirect: 'follow'
      });
    }
    form.addEventListener('input', updateSubmitState);
    form.addEventListener('change', updateSubmitState);
    window.addEventListener('pageshow', updateSubmitState);
    updateSubmitState();
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting) return;
      for (const field of [form.elements.name, form.elements.email, guest]) field.value = field.value.trim();
      updateSubmitState();
      if (button.disabled || !form.reportValidity()) return;
      error.hidden = true;
      errorKey = '';
      // Set in the Shopify section settings. Never put credentials here.
      const RSVP_ENDPOINT = root.dataset.endpoint;
      if (!/^https:\/\/script\.google\.com\/macros\/s\/[\w-]+\/exec$/.test(RSVP_ENDPOINT || '')) {
        errorKey = 'unavailable';
        refreshMessages();
        error.hidden = false;
        return;
      }
      const payload = {
        name: form.elements.name.value,
        email: form.elements.email.value,
        plusOne: form.elements.plusOne.checked ? 'yes' : 'no',
        guest: form.elements.plusOne.checked ? guest.value : ''
      };
      submitting = true;
      button.disabled = true;
      refreshMessages();
      form.setAttribute('aria-busy', 'true');
      try {
        // Apps Script accepts the POST cross-origin but does not expose its final
        // redirected response to Shopify. A fulfilled no-cors request confirms
        // that the browser completed the network handoff; server-side validation
        // and email de-duplication remain authoritative in Apps Script.
        await submitToEndpoint(RSVP_ENDPOINT, payload);
        root.querySelector('.fl-invitation').hidden = true;
        root.querySelector('.fl-confirmation').hidden = false;
        root.classList.add('fl-success');
        root.querySelector('.fl-confirmation h2').focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: 'instant' });
      } catch (_) {
        errorKey = 'failed';
        refreshMessages();
        error.hidden = false;
        status.textContent = '';
      } finally {
        submitting = false;
        updateSubmitState();
        refreshMessages();
        form.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-first-love]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-first-love]').forEach(initialize);
  });
})();
